import Vue from 'vue';
import {
  getChatReadStatus
} from '../../../services/backendService/chatService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  memberList: [],
  pushList: [],
  chatReadStatus: false,
};

// getters
const getters = {};

// actions
const actions = {
  async getChatReadStatusHandler({ commit }, fromData) {
    const data = await getChatReadStatus(fromData);
    commit('setChatReadStatus', data);
  }
};

// mutations
const mutations = {
  setChatReadStatus(state, data) {
    Vue.set(state, 'chatReadStatus', data.data.is_read);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
